import React from 'react';
import OrdersTable from 'components/Table/Orders';
import { ordersModelTrackingOrder } from 'components/Table/Orders/models';
import { Column } from 'components/Layout/Grid';
import OrderDropdown from 'components/OrderDropdown';

const TrackingOrderSlider: React.FC = () => (
  <>
    <Column className="w-100 max-w-lg-100 flex-1 px-0">
      <OrdersTable
        trackingKey="Grid Pedidos"
        tableSearchClassName=" "
        tabFilter={{ billingDate: { ne: null } }}
        model={ordersModelTrackingOrder}
        pageSize={5}
        showButton={false}
        showFilter
        DropdownTemplate={(data: any) => (
          <OrderDropdown {...data} order={data} />
        )}
        customProps={{ showItems: false, showOrderDownloadButtons: false }}
        showTypeDateFilter
      />
    </Column>
  </>
);

export default TrackingOrderSlider;
